import { connect } from 'react-redux';
import RaportNarasi from '../../../../views/Kurikulum/Raport/Cetak/RaportNarasi.view';
import { getStudent } from '../../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(RaportNarasi);
